// @flow

export const REMOVE_NOTIFICATION =
	'gobbldygook/notifications/REMOVE_NOTIFICATION'
export const LOG_MESSAGE = 'gobbldygook/notifications/LOG_MESSAGE'
export const LOG_ERROR = 'gobbldygook/notifications/LOG_ERROR'
export const START_PROGRESS = 'gobbldygook/notifications/START_PROGRESS'
export const INCREMENT_PROGRESS = 'gobbldygook/notifications/INCREMENT_PROGRESS'
